import { createExecutorForProvider } from "opencode-multi-account-core";
import { handleRateLimitResponse as handleRateLimitResponseForProvider } from "./rate-limit";
import { formatWaitTime, getAccountLabel, showToast, sleep } from "./utils";

const { executeWithAccountRotation } = createExecutorForProvider("Codex", {
  handleRateLimitResponse: async (manager, client, account, response) =>
    handleRateLimitResponseForProvider(
      manager as Parameters<typeof handleRateLimitResponseForProvider>[0],
      client,
      account,
      response,
    ),
  formatWaitTime,
  sleep,
  showToast,
  getAccountLabel,
});

export { executeWithAccountRotation };
